import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SzIcCircleAccent, SzIcCircleSize } from './sz-ic-circle.types';

@Component({
  selector: 'sz-ic-circle',
  templateUrl: './sz-ic-circle.component.html',
  styleUrls: ['./sz-ic-circle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzIcCircleComponent {
  readonly size: InputSignal<SzIcCircleSize> = input<SzIcCircleSize>('md');
  readonly accent: InputSignal<SzIcCircleAccent> = input<SzIcCircleAccent>('ghost');
}
